import D2C_TariffPlan from './Plan'

class D2C_TariffStarter extends D2C_TariffPlan {
  icon = 'user tie'
  isStarter = true
  static objectType = 'tariffType'
  static active = true
  static tariffId = '5f731985b62b534e37ef5bf3'
  static tariffTitle = 'Starter'
  static order = 15
}

export default D2C_TariffStarter
